<template>
  <div class="root">

    <ul class="ul_right">
      <li class="li_right" v-for="(item, index) in list" :key="index">
        <router-link :to="{ name: '全站搜索详情', query: { id: item.id } }" v-if="type == 1">{{ item.title
        }}</router-link>
        <router-link :to="{ name: '交易项目详情', query: { id: item.id, keys: item.keys } }" v-else>{{ item.projectname
        }}</router-link>
        <p>
          <span v-if="type == 1">来源：{{ item.source }}</span>
          <span>{{ item.createTime }}</span>
        </p>
      </li>
    </ul>

    <div v-if="list.length > 0">
      <el-pagination prev-text="上一页" next-text="下一页" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :page-size="pageSize" layout="prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
    <h3 v-else style="font-size:24px;margin-left: 20px;">暂无数据</h3>
  </div>
</template>

<script>

import { outProjectList1 } from "../api/交易项目.js";
import { getNewslist1 } from "../api/mian.js";
export default {
  data() {
    return {
      type: 1,//1新闻 2项目
      keyword: '',//关键字
      list: [],
      //   每页数据条数
      pageSize: 10,
      pageNum: 1,
      inputpage: 1,
      total: null
    };
  },
  created() {
    this.getshuju()
  },
  mounted() { },
  computed: {},
  watch: {
    $route: {
      handler: function (val, oldVal) {
        console.log(val);
        console.log(oldVal);
        this.getshuju()

      },
      // 深度观察监听
      deep: true
    }
  },
  methods: {
    getshuju() {
      this.type = this.$route.query.type;
      this.keyword = this.$route.query.keyword;
      let obj = {
        keyword: this.keyword,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
      }


      if (this.type == 2) {
        outProjectList1(obj).then(res => {
          this.list = res.data.rows;
          this.total = res.data.total;
        })

      } else if (this.type == 1) {
        getNewslist1(obj).then(res => {
          this.list = res.data.rows;
          this.total = res.data.total;

        })
      }

    },
    // 当前每页多少条
    handleSizeChange(size) {
      this.pageSize = size;
      console.log(size);
    },
    // 当前页数
    handleCurrentChange(pageNum) {
      console.log(pageNum);

      this.pageNum = pageNum;
      this.getshuju();
    },
  },
};
</script>

<style scoped>
.root {
  min-height: 1180px;
  margin: 0 auto;
  margin-bottom: 35px;
  width: 1860px;
  min-height: 300px;

  background: #ffffff;
  box-shadow: 0px 0px 24px rgba(21, 21, 21, 0.1);
  opacity: 1;
  overflow: hidden;

}

.ul_left {
  display: block;
  width: 260px;
  height: auto;
  float: left;
  /* background-color: rebeccapurple; */
  padding: 40px 100px;
  list-style: inside none;
}

.ul_left>li {
  display: block;
  width: 260px;
  height: 92px;
  /* background-color: red; */
  margin-bottom: 20px;
  cursor: pointer;
}

.ul_right {
  display: block;
  width: 100%;

  list-style: inside none;
  margin-bottom: 40px;
  box-sizing: border-box;
  padding: 0 100px;
}

.ul_right .li_right {
  display: block;
  width: 100%;
  height: 122px;
  border-bottom: 1px dotted #bebebe;
  zoom: 1.2;
}

.li_right>a {
  display: block;
  padding: 37px 0 19px 0;
  max-width: 1200px;
  height: 26px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 26px;
  color: #666666;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.li_right>p {
  display: block;
  width: auto;

  height: 21px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 21px;
  color: #999999;
}

.li_right>p>span {
  display: inline-block;
  width: 250px;
}

.el-pagination {
  text-align: center;
}
</style>